import React from "react";

const BulkDisbursements = (props) => {
  const options = [
    {
      text: 'What is Interac e-Transfer for Business: Bulk Disbursements?',
      handler: props.actionProvider.BulkDisbursements1,
      id: 1
    },
    {
      text: 'How are Bulk Disbursements priced?',
      handler: props.actionProvider.BulkDisbursements2,
      id: 2
    },
    {
      text: 'Which file formats are accepted?',
      handler: props.actionProvider.BulkDisbursements3,
      id: 3
    },
    {
      text: 'How long does it take to process the payment file?',
      handler: props.actionProvider.BulkDisbursements4,
      id: 4
    },
    {
      text: 'I have more questions, where can I find information?',
      handler: props.actionProvider.BulkDisbursements5,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransfer-products'>{optionsMarkup}</div>;
};

export default BulkDisbursements;